'use client';
import React, { useEffect, useState } from 'react';
import { icons } from '@/Icons';
import { useSettingsStoreActions, useSideNavOpen } from '@/store';

const ExpandCollapseButton = () => {
	const sideNavOpen = useSideNavOpen();
	const { setSideNavOpen } = useSettingsStoreActions();

	const [isMounted, setIsMounted] = useState(false);
	useEffect(() => {
		setIsMounted(true);
	}, []);

	useEffect(() => {
		const elementId = 'sidenav';
		const element = document.getElementById(elementId);
		if (!element) return;

		element.setAttribute('data-sidenavopen', String(sideNavOpen));
	}, [sideNavOpen]);

	return (
		<button
			aria-label="expand-collapse"
			className="   "
			onClick={() => {
				if (window.innerWidth < 768) {
					if (!sideNavOpen) {
						setSideNavOpen(true);
					}
					return;
				}
				if (sideNavOpen) {
					setSideNavOpen(false);
				} else {
					setSideNavOpen(true);
				}
			}}
		>
			<span
				className={`hidden md:flex p-1.5 h-5 w-6 bg-powder-blue rounded-[4px] justify-center items-center ${sideNavOpen && isMounted ? 'ml-auto' : 'mx-auto'}`}
			>
				<span className="h-3 w-3 relative">
					<icons.collapaseexpand
						className={`${sideNavOpen && isMounted ? '' : 'rotate-180 duration-200 ease-in-out'}`}
					/>
				</span>
			</span>
		</button>
	);
};

export default ExpandCollapseButton;
